<template>
  <section class="bt" :class="{ compact }">
    <v-container>
      <div class="bt-card" v-reveal>
        <div class="bt-copy">
          <div class="bt-badge"><v-icon small color="#1F3B35">mdi-bus-school</v-icon> Our sister company</div>
          <h2>{{ compact ? 'From the bus stop to the classroom.' : 'We get kids to school, too.' }}</h2>
          <p>
            <b>BusTrack Connect</b> is school bus tracking from the same founders as Schoolz Connect. Drivers tap
            each child on and off the bus, parents get a notification the moment it happens, and districts see
            every route live.
          </p>
          <ul>
            <li><v-icon size="18" color="#1F3B35">mdi-check-circle</v-icon>On, off and running-late alerts for parents</li>
            <li><v-icon size="18" color="#1F3B35">mdi-check-circle</v-icon>A child check so nobody is left on the bus</li>
            <li><v-icon size="18" color="#1F3B35">mdi-check-circle</v-icon>Every bus and every bus company on one live map</li>
          </ul>
          <div class="bt-btns">
            <a class="bt-btn" href="https://bustrackconnect.com" target="_blank" rel="noopener">
              Visit BusTrack Connect <v-icon size="18" color="#1F3B35">mdi-open-in-new</v-icon>
            </a>
            <router-link class="bt-link" to="/contact">Using both? Ask about pricing for both</router-link>
          </div>
        </div>

        <div class="bt-scene" aria-hidden="true">
          <div class="bt-sky"></div>
          <div class="bt-note"><div class="bt-note-ic"><v-icon size="16" color="#1F3B35">mdi-bus-school</v-icon></div><div><b>Maya got on bus 12</b><small>7:12 AM at Cedar Ln</small></div></div>
          <div class="bt-stop"><span>STOP</span><i></i></div>
          <div class="bt-road"><i></i></div>
          <div class="bt-bus">
            <div class="bb-body">
              <div class="bb-label">SCHOOL BUS</div>
              <div class="bb-windows"><i v-for="n in 5" :key="n"></i></div>
              <div class="bb-stripe"></div>
              <div class="bb-num">12</div>
            </div>
            <div class="bb-front"><i></i></div>
            <div class="bb-wheel w1"></div>
            <div class="bb-wheel w2"></div>
          </div>
        </div>
      </div>
    </v-container>
  </section>
</template>

<script>
// BusTrack Connect is a separate company. This only links to it — no data
// is shared between the two products.
export default { name: 'BusTrackBand', props: { compact: { type: Boolean, default: false } } }
</script>

<style scoped>
.bt { padding: 90px 0; }
.bt.compact { padding: 60px 0; }
.bt-card { display: grid; grid-template-columns: 1.05fr 1fr; gap: 40px; align-items: center; padding: 42px; border-radius: 28px; background: linear-gradient(160deg, #E8F2EE 0%, #D7E9F2 100%); color: #1F3B35; overflow: hidden; position: relative; }
.bt-badge { display: inline-flex; align-items: center; gap: 8px; padding: 6px 14px; border-radius: 999px; background: #F2B33D; color: #1F3B35; font-size: 0.75rem; font-weight: 800; letter-spacing: 0.08em; text-transform: uppercase; margin-bottom: 16px; }
h2 { font-family: 'Space Grotesk', 'Inter', sans-serif; font-size: clamp(1.8rem, 3.6vw, 2.6rem); font-weight: 700; line-height: 1.1; margin: 0 0 12px; color: #1F3B35; letter-spacing: -0.02em; }
p { font-size: 1.04rem; line-height: 1.7; color: #35524C; margin: 0 0 16px; }
ul { list-style: none; padding: 0; margin: 0 0 24px; display: grid; gap: 8px; }
li { display: flex; align-items: center; gap: 8px; font-weight: 600; color: #1F3B35; }
.bt-btns { display: flex; flex-wrap: wrap; align-items: center; gap: 16px; }
.bt-btn { display: inline-flex; align-items: center; gap: 8px; padding: 14px 24px; border-radius: 999px; background: #F2B33D; color: #1F3B35 !important; font-weight: 800; text-decoration: none; border: 3px solid #1F3B35; box-shadow: 0 4px 0 #1F3B35; transition: transform 0.2s, box-shadow 0.2s; }
.bt-btn:hover { transform: translateY(-2px); box-shadow: 0 6px 0 #1F3B35; }
.bt-btn:active { transform: translateY(2px); box-shadow: 0 2px 0 #1F3B35; }
.bt-link { color: #1F3B35 !important; font-weight: 700; text-decoration: underline; text-underline-offset: 3px; }

.bt-scene { position: relative; height: 280px; border-radius: 22px; background: linear-gradient(180deg, #CFE6F1 0%, #E6F2F4 70%); overflow: hidden; }
.bt-road { position: absolute; left: 0; right: 0; bottom: 0; height: 46px; background: #2E3A3A; }
.bt-road i { position: absolute; left: 0; right: 0; top: 50%; height: 4px; margin-top: -2px; background: repeating-linear-gradient(90deg, #F2B33D 0 34px, transparent 34px 70px); animation: road 1.2s linear infinite; }
@keyframes road { to { background-position: -70px 0; } }
.bt-stop { position: absolute; left: 34px; bottom: 46px; display: flex; flex-direction: column; align-items: center; }
.bt-stop span { width: 54px; height: 54px; display: grid; place-items: center; background: #D9473B; color: #fff; font-weight: 900; font-size: 13px; clip-path: polygon(30% 0, 70% 0, 100% 30%, 100% 70%, 70% 100%, 30% 100%, 0 70%, 0 30%); }
.bt-stop i { width: 4px; height: 70px; background: #7A8A8A; }
.bt-bus { position: absolute; bottom: 30px; left: 0; width: 230px; height: 104px; animation: drive 9s ease-in-out infinite; }
@keyframes drive { 0% { transform: translateX(-260px); } 38%, 58% { transform: translateX(120px); } 100% { transform: translateX(560px); } }
.bb-body { position: absolute; left: 34px; right: 0; top: 0; bottom: 14px; border-radius: 12px 14px 8px 8px; background: #F2B33D; border: 3px solid #1F3B35; }
.bb-label { text-align: center; font-size: 10px; font-weight: 900; letter-spacing: 0.18em; color: #1F3B35; margin-top: 3px; }
.bb-windows { display: flex; gap: 6px; padding: 4px 10px; }
.bb-windows i { flex: 1; height: 26px; border-radius: 4px; background: #2F4B5A; border: 2px solid #1F3B35; }
.bb-stripe { height: 4px; margin: 8px 6px 0; background: #1F3B35; border-radius: 2px; }
.bb-num { position: absolute; bottom: 6px; left: 50%; transform: translateX(-50%); padding: 0 10px; font-size: 11px; font-weight: 900; color: #F2B33D; background: #1F3B35; border-radius: 4px; }
.bb-front { position: absolute; left: 0; bottom: 14px; width: 42px; height: 52px; background: #F2B33D; border: 3px solid #1F3B35; border-right: 0; border-radius: 10px 0 0 6px; }
.bb-front i { position: absolute; left: 6px; bottom: 8px; width: 12px; height: 8px; border-radius: 2px; background: #fff; border: 2px solid #1F3B35; }
.bb-wheel { position: absolute; bottom: 0; width: 30px; height: 30px; border-radius: 50%; background: #1F3B35; border: 4px solid #2E3A3A; animation: spin 0.6s linear infinite; }
.bb-wheel::after { content: ''; position: absolute; inset: 7px; border-radius: 50%; background: repeating-conic-gradient(#C9D1D1 0 20deg, #1F3B35 20deg 90deg); }
.w1 { left: 28px; } .w2 { right: 26px; }
@keyframes spin { to { transform: rotate(360deg); } }
.bt-note { position: absolute; top: 22px; right: 18px; display: flex; gap: 10px; align-items: center; padding: 10px 14px; border-radius: 14px; background: #fff; border: 3px solid #1F3B35; box-shadow: 0 4px 0 #1F3B35; color: #1F3B35; animation: note 9s ease-in-out infinite; }
.bt-note b { display: block; font-size: 13px; }
.bt-note small { display: block; font-size: 11px; color: #4C6660; }
.bt-note-ic { width: 30px; height: 30px; border-radius: 50%; display: grid; place-items: center; background: #F2B33D; }
@keyframes note { 0%, 40% { opacity: 0; transform: translateY(-10px) scale(0.95); } 46%, 80% { opacity: 1; transform: none; } 90%, 100% { opacity: 0; transform: translateY(-6px); } }

@media (max-width: 960px) { .bt-card { grid-template-columns: 1fr; padding: 28px; } }
@media (max-width: 600px) { .bt-scene { height: 230px; } .bt-note { right: 10px; top: 12px; } }
@media (prefers-reduced-motion: reduce) {
  .bt-bus { animation: none; transform: translateX(120px); }
  .bt-road i, .bb-wheel, .bt-note { animation: none; }
  .bt-note { opacity: 1; }
}
</style>
